import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements Service
 */
export default class GetPendingPtaHttpService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.repository
   */
  constructor({repository}) {
    super()
    this._repository = repository
  }

  /**
   * @return {Promise<Number>}
   */
  execute = ({userEntity}) =>
    userEntity
      ? this._repository(userEntity).getPendingPta()
      : Promise.reject(new Error('GetPendingPtaHttpService: No pending PTA found.'))
}
